const COMMUNITY_ID = 'community';
const ALT_SUB_USER_ROLE = 'CLUB';

export const filterCommunityItems = (item, role) =>
  !(item.id === COMMUNITY_ID && role === ALT_SUB_USER_ROLE);
